import React, { useEffect, useRef } from "react"
import css from "@css/modules/BidSuggestion.module.scss"
import { ArrowDown } from "@css/icons/SVG"

export function CurrentListingPrice({ forecastToPercent, suggestedOffer }: { forecastToPercent: number; suggestedOffer: number }) {
    const rangeRef = useRef<HTMLDivElement>(null)
    const textRef = useRef<HTMLDivElement>(null)
    useEffect(() => {
        const textRect = textRef.current.getBoundingClientRect()
        const rangeRect = rangeRef.current.getBoundingClientRect()
        if (rangeRect && textRect) {
            let width = 0
            let leftSide = true
            if (textRect.left > rangeRect.left) {
                width = textRect.left - rangeRect.left
            } else if (textRect.right < rangeRect.right) {
                leftSide = false
                width = rangeRect.right - textRect.right
            }
            rangeRef.current.style.setProperty("--distanceX", `${Math.abs(width)}px`)
            rangeRef.current.style.setProperty("--left", leftSide ? "0" : "auto")
            rangeRef.current.style.setProperty("--right", !leftSide ? "1px" : "auto")
        }
    }, [])
    return (
        <>
            <div className={css.realisticRange} style={{ left: `${forecastToPercent}%`, right: `${100 - suggestedOffer}%` }}>
                <div className={css.arrowTop} ref={rangeRef}>
                    <ArrowDown width={20} />
                    <div className={css.lineRight}></div>
                </div>
            </div>
            <div className={css.realisticRangeText} ref={textRef}>
                Estimated accepted offer range
            </div>
        </>
    )
}
